'use strict';

import angular from 'angular';

var dashboard =  function ($q, $http, utils, userModel, modal) {
  'ngInject';

  return {
    fetch: function () {
      const promise = new $q((resolve, reject) => {
        $http.get(utils.getApiUrl(`dashboard/${userModel.item.id}`))
          .then(response => {
            const responseData = response.data;

            this.balance = responseData.balance;
            this.history = responseData.history;
            this.account = responseData.account;
            this.userInfo = responseData.userInfo;
            this.metaData = responseData.metaData;
            this.supportedCountries = responseData.supportedCountries;

            resolve();
          })
          .catch(reject)
          .finally(() => {
            delete this.isFetching;
          });
      });

      this.isFetching = promise;

      return promise;
    },

    saveBankAccountInfo: function (billingInfo) {
      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrl(`dashboard/${userModel.item.id}/edit`), billingInfo)
          .then((response) => {
            this.userInfo = response.data;
            resolve();
          })
          .catch(reject);
      });
    },

    payout: function () {
      const postData = {
        bookings: this.balance.availableBookings
      };
      const config = {
        params: {
          type: 'bank'
        }
      };
      let promise;

      if (!(this.userInfo && this.userInfo.bankAccount && this.userInfo.bankAccount.accountNumber)) {
        promise = this.openBankAccountModal();
      }

      promise = $q.resolve(promise)
        .then(() => {
          return $q((resolve, reject) => {
            $http.post(utils.getApiUrl(`dashboard/${userModel.item.id}/payout`), postData, config)
              .then((response) => {
                const payoutEvent = response.data;

                this.balance.available = 0;
                this.history.unshift(payoutEvent);

                resolve(response.data);
              })
              .catch(reject);
          });
        });

      return promise;
    },

    openBankAccountModal: function () {
      const modalInstance = modal.open({
        template: '<bank-account-form done="close()"></bank-account-form>',
        closeOnStateChange: true
      });

      return modalInstance.result;
    }
  };
};

export default angular
  .module('dashboard.dashboard', [])
  .service('dashboard', dashboard)
  .name;




// WEBPACK FOOTER //
// ./app/src/modules/dashboard/dashboard.service.js